export const GET_TRANSACTIONS_REQUEST =
  'legacy.investor.GET_TRANSACTIONS_REQUEST'
export const GET_TRANSACTIONS_SUCCESS =
  'legacy.investor.GET_TRANSACTIONS_SUCCESS'
export const GET_TRANSACTIONS_FAILURE =
  'legacy.investor.GET_TRANSACTIONS_FAILURE'
